import { Component, Input } from '@angular/core';
import { Ink } from '@design-system/typography/ink';
import { CommonModule } from '@angular/common';
import { BaseTypographyComponent } from '../base-typography.component';
@Component({
  selector: 'app-h4',
  template: '<h4 class="{{ngClass}}"><ng-content></ng-content></h4>',
  styleUrls: ['./h4.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class H4Component extends BaseTypographyComponent {
  /** H4 SCSS defaults to muted `ink-50` (not the shared typography `ink-85`). */
  @Input() override ink: Ink = 'ink-50';
  @Input() noWrap?: boolean;
  @Input() center?: boolean;
  @Input() backgroundColor: Ink = 'primary';
  @Input() usePadding = false;

  override get ngClass(): string[] {
    return [
      this.noMargin !== undefined ? 'no-margin' : '',
      this.noWrap !== undefined ? 'no-wrap' : '',
      this.center !== undefined ? 'center' : '',
      this.ink,
      this.backgroundColor ? 'background-' + this.backgroundColor : '',
      this.usePadding ? 'use-padding' : ''
    ];
  }
}
